import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PersonProfileRoleForm } from '../forms/PersonProfileRoleForm';

type PersonProfileRoleModalProps = {
  personUuid: string;
  personName: string;
  isOpen: boolean;
  onClose: () => void;
};

export const PersonProfileRoleModal = ({ personUuid, personName, isOpen, onClose }: PersonProfileRoleModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      width='s'
      title={t('profiles.changeRoleFor', { name: personName })}
      isOpen={isOpen}
      loading={loading}
      onRequestClose={() => onClose()}
    >
      <PersonProfileRoleForm
        personUuid={personUuid}
        onLoad={(loading) => setLoading(loading)}
        onClose={() => onClose()}
      />
    </Modal>
  );
};
